import * as React from 'react';
import { text } from 'src/common/text';
import { SchoolOption } from '../domain/SchoolOption';

import '../styles/VisitedSchool.css';

interface VisitedSchoolProps {
  schoolOption: SchoolOption;
  onRemove: (schoolId: number) => void;
}

/**
 * Komponente zur Anzeige einer besuchten Schule
 * @param {VisitedSchoolProps} props
 * @returns {JSX.Element}
 */
export const VisitedSchool: React.FC<VisitedSchoolProps> = ({
  onRemove,
  schoolOption: { id, label, subLabel, url },
}) => {
  const handleRemove = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    onRemove(id);
  };

  return (
    <a
      className="visited-school"
      href={url}
      style={{
        display: 'flex',
        width: '100%',
        borderRadius: 4,
        marginBottom: 8,
        flexDirection: 'row',
        alignItems: 'flex-start',
      }}
    >
      <div style={{ flexGrow: 1, paddingTop: 8, paddingBottom: 8, paddingLeft: 16 }}>
        <h3
          style={{
            color: '#414D55',
            fontSize: '14px',
            lineHeight: '19px',
            marginBottom: 4,
          }}
        >
          {label}
        </h3>
        <span
          style={{
            color: '#293035',
            fontSize: '14px',
            letterSpacing: '0',
            lineHeight: '19px',
          }}
        >
          {subLabel}
        </span>
      </div>
      <button onClick={handleRemove} title={text('LBL_REMOVE_RECENT_SEARCH_ITEM')}>
        <img src="img/icons/cross.svg" />
      </button>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/components/VisitedSchool.tsx